import React, { useState } from "react";
import {
  Modal,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import WarningIcon from "@mui/icons-material/Warning";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const GstApplicableSwitchModal = ({
  open,
  setOpen,
  warningText,
  setData,
  gstFlag,
  todayDate,
  items,
  itemsEdited,
  itemsTemp,
  setItemEntry,
  nonItems,
  nonItemsEdited,
  nonItemsTemp,
  nonGstItems,
  nonGstItemEditedRow,
  nonGstItemTempRow,
  GstType,
  type
}) => {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  function switchToTable() {
    setData((prev) => ({
      ...prev,
      ["gstApplicable"]: gstFlag,
      ["partyName"]: { label: "", value: "" },
      ["billingAddress"]: "",
      ["deliveryAddress"]: "",
      ["creditNote"]: "",
      ["originalInvoiceNumber"]:[{ label: "", value: "" }],
      ["creditNoteDate"]: todayDate,
      ["paymentType"]: "",
      ["recordAmount"]: "",
      ["creditToAccount"]: "",
      ["attachments"]: "",
      ["bankRefNo"]: "",
      ["vehicleNumber"]: "",
      ["adjustments"]: "",
      ["transpotationMode"]: "",
      ["dateOfDispatch"]: "",
      ["eWayBill"]: "",
      ["remarks"]:"",
      ["errorStatus"]: {
        ...prev.errorStatus,
        ["gstApplicable"]: false,
        ["partyName"]: false,
        ["billingAddress"]: false,
        ["deliveryAddress"]: false,
        ["creditNote"]: false,
        ["originalInvoiceNumber"]: false,
        ["creditNoteDate"]: "",
        ["paymentType"]: false,
        ["recordAmount"]: false,
        ["creditToAccount"]: false,
        ["attachments"]: false,
        ["adjustments"]: false,
        ["bankRefNo"]: false,
        ["vehicleNumber"]: false,
        ["transpotationMode"]: false,
        ["dateOfDispatch"]: false,
        ["eWayBill"]: false,
        ["remarks"]:false
      },
      ["errorFields"]: {
        ...prev.errorFields,
        ["gstApplicable"]: "",
        ["partyName"]: "",
        ["billingAddress"]: "",
        ["deliveryAddress"]: "",
        ["creditNote"]: "",
        ["originalInvoiceNumber"]: "",
        ["creditNoteDate"]: "",
        ["paymentType"]: "",
        ["recordAmount"]: "",
        ["creditToAccount"]: "",
        ["adjustments"]: "",
        ["attachments"]: "",
        ["bankRefNo"]: "",
        ["vehicleNumber"]: "",
        ["transpotationMode"]: "",
        ["dateOfDispatch"]: "",
        ["eWayBill"]: "",
        ["remarks"]:""
      },
    }));
    if (GstType == "1") {
      // setItemEntry(false)
      setOpen(false);
      items([])
      items((prev) => [
        ...prev,
        {
          itemCode: { label: "", value: "" },
          name: { label: "", value: "" },
          purchaseAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          qty: 1,
          units: "",
          rate: 0,
          amount: 0,
          dicount: 0,
          taxableAMount: 0,
          GSTRate: "",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        },
      
      ]);
      itemsEdited({})
      itemsEdited({
        itemCode: { label: "", value: "" },
        name: { label: "", value: "" },
        purchaseAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        qty: 1,
        units: "",
        rate: 0,
        amount: 0,
        dicount: 0,
        taxableAMount: 0,
        GSTRate: "",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
      itemsTemp({});
      itemsTemp({
        itemCode: { label: "", value: "" },
        name: { label: "", value: "" },
        purchaseAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        qty: 1,
        units: "",
        rate: 0,
        amount: 0,
        dicount: 0,
        taxableAMount: 0,
        GSTRate: "",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
      
      nonItems([])
      nonItems((prev) => [
        ...prev,
        {
          ledgerAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          description: "",
          taxAMount: 0,
          GSTRate: "0",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        },
      ]);
      nonItemsEdited({})
      nonItemsEdited ({
        ledgerAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        description: "",
        taxAMount: 0,
        GSTRate: "0",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      })
      nonItemsTemp({})
      nonItemsTemp({
        ledgerAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        description: "",
        taxAMount: 0,
        GSTRate: "0",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      })
    }else{
      // setItemEntry(true)
      setOpen(false);
      if(type=="Credit"){
      nonGstItems([])
      nonGstItems((prev) => [
        ...prev,
        {
          ledgerAccount: { label: "", value: "" },
          description: "",
          amount: "",
          editable: true,
          new: true,
        },
      ]);
     
      nonGstItemEditedRow({})
      nonGstItemEditedRow({
        ledgerAccount: { label: "", value: "" },
        description: "",
        amount: "",
        editable: true,
        new: true,
      });
      nonGstItemTempRow({})
      nonGstItemTempRow ({
        ledgerAccount: { label: "", value: "" },
        description: "",
        amount: "",
        editable: true,
        new: true,
      });
    }else{
      nonGstItems([])
      nonGstItems((prev) => [
        ...prev,
        {
          ledgerAccount: { label: "", value: "" },
          description: "",
          taxableAMount: "",
          editable: true,
          new: true,
        },
      ]);
     
      nonGstItemEditedRow({})
      nonGstItemEditedRow({
        ledgerAccount: { label: "", value: "" },
        description: "",
        taxableAMount: "",
        editable: true,
        new: true,
      });
      nonGstItemTempRow({})
      nonGstItemTempRow ({
        ledgerAccount: { label: "", value: "" },
        description: "",
        taxableAMount: "",
        editable: true,
        new: true,
      });
    }
 

  }
    setOpen(false);
  }
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            backgroundColor: "white",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <IconButton
            aria-label="delete"
            sx={{ marginBottom: "10px", backgroundColor: "#ffd55770" }}
          >
            <WarningIcon sx={{ fontSize: "35px", color: "#ffc107" }} />
          </IconButton>
          <Typography fontWeight={400} textTransform="capitalize">
            Warning
          </Typography>
          <Typography sx={{ color: "#b28704", fontSize: "14px" }}>
            {warningText}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            color="primary"
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={switchToTable}
            variant="contained"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            OK
          </Button>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default GstApplicableSwitchModal;
